import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["message"];

  connect() {
    this.showMessage();
  }

  showMessage() {
    setTimeout(() => {
      $(this.messageTarget).show().delay(2000).fadeOut("slow");

    }, 0);
  }
}